<template lang="pug">
  b-container.d-column(fluid)
    empty-message(message="Completando proceso" )
    b-spinner.mx-auto(variant="primary")
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'GoogleapisCallback',
    data () {
      return {
        loading: true
      }
    },
    computed: {},
    methods: {
      ...mapActions(['googleapis_credential/create']),
      createCredential(code, account_id) {
        this['googleapis_credential/create']({
          account_id,
          code,
          callback: res => {
            if (res.error) this.$message.error(res.error)
            else if(res.message) this.$message.warning('La cuenta ya ha se encuentra asociada')
            else this.$message.success('Cuenta asociada')
            this.$router.push({ name: 'GoogleCalendars', params: { account_id } })
          }
        })
      }
    },
    mounted () {
      const { code, state = '{}' } = this.$route.query
      const { account_id } = JSON.parse(state)

      if(!code) {
        this.$message.warning('Ocurrió un error con la autenticación o los consentimientos de permisos ')
        this.$router.push({ name: 'GoogleCalendars', params: { account_id } })
        return
      }

      this.createCredential(code, account_id)
    }
  }
</script>

<style scoped lang="scss">
  .d-column {
    display: flex;
    flex-flow: column;
    align-content: center;
    justify-content: center;
    height: 100%;
  }
</style>